@if (this.showInput) { @if (this.user.companyOwner.isMain) { @if (this.showFloatLabel) {
<div class="p-float-label">
  <p-dropdown
    id="companyOwner"
    [options]="this.companiesList()"
    optionLabel="nameCompany"
    optionValue="id"
    [showClear]="false"
    placeholder="Selecciona la empresa"
    styleClass="w-full min-w-[13rem]"
    [disabled]="disabled"
    [ngModel]="value"
    (onChange)="onSelect($event)" />

  <label [hidden]="this.hiddenLabel" for="float-label">Empresa asociada</label>
</div>
} @else {

<div class="flex flex-col gap-2">
  @if (this.showSimpleLabel) {
  <label [hidden]="this.hiddenLabel">Empresa asociada</label>
  } @else {
  <label [hidden]="this.hiddenLabel" class="text-sm font-medium text-gray-700">Empresa asociada</label>
  }
  <p-dropdown
    id="companyOwner2"
    [options]="this.companiesList()"
    optionLabel="nameCompany"
    optionValue="id"
    [showClear]="false"
    placeholder="Selecciona la empresa"
    styleClass="w-full min-w-[13rem]"
    [disabled]="disabled"
    [ngModel]="value"
    (onChange)="onSelect($event)" />
</div>
} } }
